var urlOpt = {
  local: "http://47.94.243.177:8888/",
  qa: "http://192.168.31.88:9999/",
  online: "http://rest.iloveplanet.cn/"
}
var linkType = "online" 

module.exports = urlOpt[linkType]
